import { __rest } from "tslib";
import * as React from 'react';
import { observer } from 'mobx-react';
import ExpandIcon from '@patternfly/react-icons/dist/esm/icons/expand-alt-icon';
import { TaskNode } from '../nodes';
const DefaultTaskGroupCollapsed = (_a) => {
    var { element, shadowCount = 2, collapsible, onCollapseChange } = _a, rest = __rest(_a, ["element", "shadowCount", "collapsible", "onCollapseChange"]);
    return (React.createElement(TaskNode, Object.assign({ element: element, actionIcon: collapsible ? React.createElement(ExpandIcon, null) : undefined, onActionIconClick: () => onCollapseChange(element, false), shadowCount: shadowCount }, rest)));
};
export default observer(DefaultTaskGroupCollapsed);
//# sourceMappingURL=DefaultTaskGroupCollapsed.js.map